import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => {
  if(Cookies.get('popup') !== undefined) {
    document.querySelector('html').classList.remove('consent-on');
  }
  else {
    document.querySelector('html').classList.add('consent-on');
  }

  if (document.querySelector('#letmein')) {
    document.querySelector('#letmein').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('html').classList.remove('consent-on');
      Cookies.set('popup', '1', { expires: 30 });
    })
  }

});
